import React, { useState,useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { baseapi } from "../../Environmentalurl";
import {
  ApplicationType,
  entity_id,
  getGeolocation,
  locationGeo,
  Platform,
} from "../../Utils/Const";
import useIPAddress from "../../Utils/useIPAddress";

export default function ProfileDetails() {
  const [idType, setIdType] = useState("");
  const location = useLocation();
  const mobile = location.state?.mobile;
  
 const ip = useIPAddress();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    idType: "",
    idNumber: "",
    email: "",
    dob: "",
    gender: "",
    aadhaarRefNo: "",
    aadhaarStatus: "",
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const steps = [
    "Mobile verification",
    "Profile Details",
    "Security Checkup",
    "Complete",
  ];

  const navigate = useNavigate();

  const fetchAadhaarRefNo = async (aadhaarNumber) => {
    try {
      const response = await fetch(`${baseapi}/auth/aadhaarRefNo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          AadhaarNumber: aadhaarNumber,
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
          Platform: Platform,
          Purpose: "Full KYC POA",
          ReqType: "Jan_Aadhaar_eWallet_GetAadhaarRefNumber",
        }),
      });

      const data = await response.json();

      if (data.Response_Code === "1000") {
        // SUCCESS
        setFormData((prev) => ({
          ...prev,
          aadhaarRefNo: data.RefNo,
          aadhaarStatus: 1,
        }));
        return true;
      } else {
        // FAILURE
        setFormData((prev) => ({
          ...prev,
          aadhaarRefNo: "",
          aadhaarStatus: 0,
        }));
        return false;
      }
    } catch (error) {
      console.error("Aadhaar API Error", error);
      setFormData((prev) => ({
        ...prev,
        aadhaarRefNo: "",
        aadhaarStatus: 0,
      }));
      return false;
    }
  };

  const createpassword = async () => {
    if (formData.idType === "Aadhaar") {
      const success = await fetchAadhaarRefNo(formData.idNumber);

      if (!success) {
        alert("Aadhaar verification failed. Please try again.");
        return;
      }
    } else {
      // Driving License case
      setFormData((prev) => ({
        ...prev,
        aadhaarStatus: 0,
        aadhaarRefNo: "",
      }));
    }

    // Navigate to next page with updated data
    navigate("/registration/lowkyc/createtpin", {
      state: {
        ...formData,
        mobile: mobile,
      },
    });
  };

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: "#f5f7f6", p: 3 }}>
        <Box
          sx={{
            minHeight: "100vh",
            bgcolor: "#f5f7f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Container maxWidth="md">
            <Box
              sx={{
                bgcolor: "white",
                borderRadius: 3,
                display: "flex",
                overflow: "hidden",
                minHeight: 480,
                boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
              }}
            >
              {/* LEFT PANEL */}
              <Box
                sx={{
                  width: "40%",
                  bgcolor: "#0aa34f",
                }}
              />

              {/* RIGHT FORM */}
              <Box sx={{ width: "60%", p: 5 }}>
                <Typography
                  sx={{
                    cursor: "pointer",
                    mb: 2,
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#3d7f45",
                    fontWeight: 500,
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => navigate("/registration/lowkyc/verify-otp")}
                >
                  ← Back
                </Typography>

                <Stepper activeStep={1} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>

                <Box mt={4}>
                  <TextField
                    label="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    select
                    label="Identification Type"
                    name="idType"
                    value={formData.idType}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="Aadhaar">Aadhaar Number</MenuItem>
                    <MenuItem value="Driving License">Driving License</MenuItem>
                  </TextField>

                  <TextField
                    label={
                      formData.idType
                        ? `${formData.idType} Number`
                        : "Identification Number"
                    }
                    name="idNumber"
                    value={formData.idNumber}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="Email ID"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="Date Of Birth"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mb: 1 }}
                  />

                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Gender</InputLabel>
                    <Select
                      label="Gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                    >
                      <MenuItem value="">Select Gender</MenuItem>
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                      <MenuItem value="Others">Others</MenuItem>
                    </Select>
                  </FormControl>

                  <Typography fontSize={12} color="text.secondary" mb={2}>
                    * Note: Below 18 years are not eligible
                  </Typography>

                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 2,
                      bgcolor: "#0aa34f",
                      py: 1.4,
                      fontSize: 15,
                      "&:hover": { bgcolor: "#0aa34f" },
                      color: "white",
                    }}
                    onClick={createpassword}
                  >
                    Submit
                  </Button>
                </Box>

                <Typography textAlign="center" mt={4} fontSize={14}>
                  Having Trouble?{" "}
                  <span style={{ color: "#3d7f45", cursor: "pointer" }}>
                    Contact Support
                  </span>{" "}
                  |{" "}
                  <span style={{ color: "#3d7f45", cursor: "pointer" }}>
                    FAQ
                  </span>
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
